import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import Helmet from "react-helmet";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { CheckActionPermission } from "../../../../../../Actions/commonAction";
import uploadIcon from "../../../../../../Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import signatoryImg from "../../../../../../Assets/Svg/signatory.svg";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import DrawerHeader from "../../../../../../Component/Headers/drawerHeader";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import SearchSq from "../../../../../../Component/Material-ui/SearchSq";
import Thumbnail from "../../../../../../Component/Thumbnail/ThumbnailBig";
import { ErrorMessages } from "../../../../../../Constants";
import CustomLoader from "Component/CustomLoader";

import {
  fileToBase64Link,
  getFormattedImageLink,
} from "../../../../../../Utils";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";
import Details from "./details";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class Signatories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      DrawerOpen: false,
      SignatoryDrawer: false,
      createmenu: false,
      create_anchorEl: null,
      permissions: { editable: false, readonly: false },
      list: [],
      vsignature: "",
      viewhistory: false,
      signatories: {
        headers: [
          {
            key: "fullname",
            name: "Full name",
            style: { textAlign: "left", width: "40%" },
            type: TDTypeConsts.SIGNATORY_NAME,
          },
          {
            key: "signaturepath",
            name: "Virtual signature",
            type: TDTypeConsts.DATA_PREVIEW,
          },
          {
            key: "isactive",
            name: "Status",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },
          {
            key: "moreoptions",
            type: TDTypeConsts.MORE_OPTIONS,
          },
        ],
      },
      selectedEmp: null,
      selectedRow: {},
      empList: [],
      backupList: [],
      sigDetails: {},
      datareceived: false,
    };
    this.getSignatories = this.getSignatories.bind(this);
    this._renderList = this._renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.addSignatoryDrawer = this.addSignatoryDrawer.bind(this);
    this.CloseSignatoryDrawer = this.CloseSignatoryDrawer.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.createNewMenuClose = this.createNewMenuClose.bind(this);
    this.reUpload = this.reUpload.bind(this);
    this._renderSignatoryDetails = this._renderSignatoryDetails.bind(this);
    this.submit = this.submit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("signatories");
    if (isTrue) {
      this.setState({ permissions: { editable: true, readOnly: true } }, () => {
        this.getSignatories();
        this.getAllEmp();
      });
      if (this.props.history.location.pathname.includes("create")) {
        this.props.history.push(`${this.props.match.path}`);
      }
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getAllEmp() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "signatories",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        this.setState({
          empList: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  openDrawer({ DrawerOpen }) {
    this.setState({
      DrawerOpen,
    });
  }

  addSignatoryDrawer() {
    this.setState({
      SignatoryDrawer: true,
      uploadimg: "",
      selectedEmp: null,
    });
  }

  CloseSignatoryDrawer() {
    this.setState({
      SignatoryDrawer: false,
      selectedId: null,
      uploadimg: null,
      selectedEmp: null,
    });
  }

  handleClickAway() {
    this.setState({
      DrawerOpen: false,
    });
  }

  handleChange = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  createNewMenuClose() {
    this.setState({ createmenu: false });
  }

  getSignatories() {
    this.setState({isLoading:true}, () => {
      instance.get("letter/getallsignatory").then((resp) => {
        this.setState({
          list: resp.data.result,
          backupList: resp.data.result,
          // datareceived: true,
          isLoading:false
        });
      });
    })
   
  }

  _renderSignatoryDetails() {
    const { selectedRow } = this.state;
    instance
      .get(`letter/signatorydetail/${selectedRow.employeeid}`)
      .then((result) => {
        this.setState({
          sigDetails: result.data.result[0],
          viewhistory: true,
          createmenu: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onCreate() {
    this.setState({
      SignatoryDrawer: true,
    });
  }

  onDelete = () => {
    const { selectedRow } = this.state;
    this.props.enqueueSnackbar(ErrorMessages.E1440, {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            instance
              .delete(`letter/deletesignatory/${selectedRow.signatoryid}`)
              .then(() => {
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
                this.getSignatories();
                this.props.closeSnackbar();
                this.setState({
                  createmenu: false,
                });
              })
              .catch((error) => {
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
                this.setState({
                  createmenu: false,
                });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  onStateStatusChange = (val, row) => {
    // this.props.enqueueSnackbar(ErrorMessages.E1070, {
    //   variant: "warning",
    //   action: [
    //     <Button
    //       color="inherit"
    //       size="small"
    //       onClick={() => {
    instance
      .put(`letter/activeinactivesignatory/${row.signatoryid}/${!row.isactive}`)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.getSignatories();
        this.props.closeSnackbar();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
    //       }}
    //  >
    //       Yes
    //     </Button>,
    //     <Button color="inherit" size="small" onClick={() => this.props.closeSnackbar()}>
    //       No
    //     </Button>,
    //   ],
    // });
  };

  onDeleteDoc(key) {
    this.setState({
      [key]: "",
    });
  }

  async uploadDoc(key, files) {
    const file = files[0];
    const x = await fileToBase64Link(file);
    const data = {
      filename: file.name,
      appproductid: null,
      contenttype: file.type,
      bufferdata: x,
      employeeid: null,
    };
    const result = await instance.post("employee/uploadbufferfile", data);
    this.setState({
      [key]: result.data.result[0].imagepath,
    });
  }

  async reUpload(files) {
    const { selectedRow } = this.state;
    const file = files[0];
    const x = await fileToBase64Link(file);
    const data = {
      filename: file.name,
      appproductid: null,
      contenttype: file.type,
      bufferdata: x,
      employeeid: null,
    };
    const result = await instance.post("employee/uploadbufferfile", data);
    const data1 = {
      employeeid: selectedRow.employeeid,
      signaturepath: result.data.result[0].imagepath,
      signatoryid: selectedRow.signatoryid,
    };
    instance
      .post(`letter/configsignatory`, data1)
      .then(() => {
        this.props.enqueueSnackbar("Saved successfully", {
          variant: "success",
        });
        this.getSignatories();
        this.setState({
          SignatoryDrawer: false,
          createmenu: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  submit() {
    const { uploadimg, selectedEmp, selectedId } = this.state;
    if (uploadimg) {
      const data = {
        employeeid: selectedEmp,
        signaturepath: uploadimg,
        signatoryid: selectedId,
      };
      instance
        .post(`letter/configsignatory`, data)
        .then(() => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.getSignatories();
          this.setState({
            SignatoryDrawer: false,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      this.props.enqueueSnackbar("Please upload signature", {
        variant: "error",
      });
    }
  }

  handleSearch(e) {
    const { backupList, list } = this.state;
    const filterList = list.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      list: e.target.value ? filterList : backupList,
    });
  }

  _renderList() {
    const { viewhistory, uploadimg } = this.state;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.AuthorizedSignatory.header}</title>
        </Helmet>
        {viewhistory ? (
          <div>
            <Grid container>
              <Grid item xs={12} md={2} sm={2}>
                <PageHeader header="Signatory history" />
              </Grid>
              <Grid
                item
                md={10}
                sm={2}
                justify="flex-end"
                className="display-flex"
              >
                <span className="floatleft">
                  <Button
                    variant="contained"
                    className="btn btn-secondary-md-blue"
                    color="primary"
                    onClick={() =>
                      this.setState({
                        viewhistory: false,
                      })
                    }
                  >
                    Back
                  </Button>
                </span>
              </Grid>
            </Grid>
            <Details {...this.props} {...this.state} />
          </div>
        ) : (
          <div>
            {this.state.isLoading ?
            <CustomLoader/>
         :   <div>
            {this.state.list && this.state.list.length > 0 ? (
              <div>
                <Grid container>
                  <Grid item md={2} sm={2}>
                    <PageHeader header="Signatories" />
                  </Grid>
                  <Grid
                    item
                    md={10}
                    sm={2}
                    justify="flex-end"
                    className="display-flex"
                  >
                    <div>
                      <div className="floatleft margin-right-16">
                        <SearchSq
                          placeholder="Search signatories"
                          value={this.state.searchValue}
                          onChange={this.handleSearch}
                        />
                      </div>
                      {this.state.permissions.editable && (
                        <span className="floatleft">
                          <Button
                            variant="contained"
                            className="btn btn-primary-md-blue"
                            color="primary"
                            onClick={this.addSignatoryDrawer}
                          >
                            Add signatory
                          </Button>
                        </span>
                      )}
                    </div>
                  </Grid>
                </Grid>
                <div className="position-rel">
                 <List
                    showOnlyList
                    list={this.state.list}
                    permissions={this.state.permissions}
                    headers={this.state.signatories.headers}
                    onEdit={this.onEdit}
                    onDelete={this.onDelete}
                    onMoreOptionClick={(e, row) =>
                      this.onMoreOptionClick(e, row)
                    }
                    onStateStatusChange={this.onStateStatusChange}
                  />
              
                </div>
              </div>
            ) : (
              <CreateComp
                text="Signatories are the people who sign a letter. In this page you can add signatories and upload their virtual signature so that sumHR can insert their signature (image) in the respective letters."
                heading="Concept of Signatories "
                onCreate={this.addSignatoryDrawer}
                imageSrc={signatoryImg}
                permissions={this.state.permissions}
              />
            )}
            </div>
            }
          </div>
        )}
        <Drawer
          anchor="right"
          open={this.state.SignatoryDrawer}
          onClose={this.CloseSignatoryDrawer}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <DrawerHeader
            header="Add signatory"
            isbackarrow={false}
            closeDrawer={this.CloseSignatoryDrawer}
          />
          <div>
            <div>
              <DynamicForm
                fields={selectinputconverter({
                  value: this.state.selectedEmp,
                  options: this.state.empList,
                  placeholder: "Select employee",
                  label: "Employee ",
                })}
                onChange={(e) => this.handleChange("selectedEmp", e)}
              />
            </div>
            <div>
              <p className="input-label">Signature</p>
              {!uploadimg ? (
                <Tooltip title="Upload image" placement="top">
                  <Dropzone
                    onDrop={(e) => this.uploadDoc("uploadimg", e)}
                    multiple={false}
                    accept="image/*"
                    maxSize={2000000}
                    className="drag-drop"
                  >
                    <div
                      className="cursor-pointer"
                      style={{
                        height: 49,
                        width: 150,
                        border: "1px dashed #507cff",
                      }}
                    >
                      <div
                        style={{
                          height: 20,
                          width: 150,
                          textAlign: "center",
                          marginTop: 11,
                        }}
                      >
                        <img src={uploadIcon} className="vertical-middle"></img>
                        <span className="margin-left-16 small-blue">
                          Upload image
                        </span>
                      </div>
                    </div>
                  </Dropzone>
                </Tooltip>
              ) : (
                <Thumbnail
                  key="key"
                  onDelete={() => this.onDeleteDoc("uploadimg")}
                  onEdit={(file) => this.uploadDoc("uploadimg", file)}
                  filetypes="image/*"
                  doc={{ url: getFormattedImageLink(uploadimg) }}
                />
              )}
              <p className="input-label">
                Note: Upload image with max size 2 MB for optimum results.
                (Supports image/* file types)
              </p>
            </div>
            <div style={{ marginTop: 20 }}>
              <Button
                variant="contained"
                className="btn btn-primary-md-blue margin-right-16"
                color="primary"
                onClick={this.submit}
              >
                Save
              </Button>
            </div>
          </div>
        </Drawer>
      </div>
    );
  }

  render() {
    const { match } = this.props;
    const { datareceived } = this.state;
    return (
      // datareceived && (
        <div>
          <IntlProvider locale="en">
            <div className="content-outer-wrapper">
              {this.state.permissiondenied ? (
                <div className="position-rel">
                  <PermissionDeniedComp />
                </div>
              ) : (
                <div>
                  <Switch>
                    <Route
                      exact
                      path={`${match.path}`}
                      render={this._renderList}
                    />
                    <Redirect from={`${match.path}`} to={`${match.path}`} />
                  </Switch>
                  <Popover
                    open={this.state.createmenu}
                    anchorEl={this.state.create_anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    onClose={this.createNewMenuClose}
                    className="margin-top-8"
                  >
                    <Paper style={{ width: 190 }}>
                      <div>
                        <MenuListComponent>
                          <ListItem className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer">
                            <ListItemText style={{ padding: 0 }}>
                              <Dropzone
                                onDrop={(files) => this.reUpload(files)}
                                // onFileDialogCancel={this.onCancelFile}
                                multiple={true}
                                accept=".xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,.odt,.csv,.key,.ods,
                            .zip,.rar,.7z,.gzip,.apk,.ipa,
                            image/jpg,image/jpeg,image/png,image/tiff,image/gif,
                            .wav,.mp3,.aac,.ogg,.wma,.flac,
                            .avi,.flv,.mkv,.mov,.mp4,.webm,.wmv"
                                maxSize={25670000}
                                className="drag-drop"
                              >
                                <span className="small-dark-secondary">
                                  Re-upload signature
                                </span>
                              </Dropzone>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={this._renderSignatoryDetails}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                View history{" "}
                              </span>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={this.onDelete}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Delete{" "}
                              </span>
                            </ListItemText>
                          </ListItem>
                        </MenuListComponent>
                      </div>
                    </Paper>
                  </Popover>
                </div>
              )}
            </div>
          </IntlProvider>
        </div>
      // )
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
  ExitReasonsReducer: state.ExitReasonsReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withSnackbar(Signatories))),
);
